import { render, staticRenderFns } from "./RequestCalls.vue?vue&type=template&id=bfc58c06&scoped=true&"
import script from "./RequestCalls.vue?vue&type=script&lang=js&"
export * from "./RequestCalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc58c06",
  null
  
)

export default component.exports